module.exports = __webpack_public_path__ + "img/-e-photo_02@2x.0cb3a416.png";